module.exports = __webpack_public_path__ + "static/img/gongys.b29bbfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gongys.png
// module id = ci00
// module chunks = 1